/**
 * Vuex 用户信息模块
 * 用于管理用户登录状态、用户信息以及持久化到 sessionStorage
 */

export default {
  namespaced: true,

  state: {
    user: {
      token: sessionStorage.getItem('token') || null,
      userId: sessionStorage.getItem('userId') || null,
      userAccount: sessionStorage.getItem('userAccount') || '',
      roleId: sessionStorage.getItem('roleId') || null,
      roleName: sessionStorage.getItem('roleName') || ''
    }
  },

  mutations: {
    SET_USER_INFO(state, payload) {
      state.user = { ...state.user, ...payload }
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          sessionStorage.setItem(key, value)
        }
      })
    },

    CLEAR_USER_INFO(state) {
      state.user = {
        token: null,
        userId: null,
        userAccount: '',
        roleId: null,
        roleName: ''
      }
      const keys = ['token', 'userId', 'userAccount', 'roleId', 'roleName']
      keys.forEach((key) => {
        sessionStorage.removeItem(key)
      })
    },

    UPDATE_USER_INFO(state, payload) {
      state.user = { ...state.user, ...payload }
      Object.entries(payload).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          sessionStorage.setItem(key, value)
        }
      })
    }
  },

  actions: {
    login({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },

    logout({ commit }) {
      commit('CLEAR_USER_INFO')
      sessionStorage.clear()
    },

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    }
  },

  getters: {
    isAuthenticated: state => !!state.user.token,
    currentUser: state => state.user,
    userId: state => state.user.userId,
    userAccount: state => state.user.userAccount,
    roleId: state => state.user.roleId,
    roleName: state => state.user.roleName,
    // 获取 Token（用于 WebSocket 认证）
    token: state => state.user.token,

    // 角色判断（基于 roleId）
    isSuperAdmin: state => Number(state.user.roleId) === 0, // 超级管理员
    isNormalAdmin: state => Number(state.user.roleId) === 1, // 管理员
    isNormalUser: state => Number(state.user.roleId) === 2, // 普通用户

    // 是否有管理权限（超级管理员 或 管理员）
    hasManagePermission: state => {
      const roleId = Number(state.user.roleId)
      return roleId === 0 || roleId === 1
    },

    // 是否是管理员（超级管理员 或 管理员）
    isAdmin: state => {
      const roleId = Number(state.user.roleId)
      return roleId === 0 || roleId === 1
    }
  }
}
